<template>
  <li class="dropdown dropdown-language nav-item">
    <a class="dropdown-toggle nav-link" id="dropdown-flag" href="javascript:void(0);" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="flag-icon" :class="`flag-icon-${activeLanguageItem.flag}`"></i>
      <span class="selected-language">{{ activeLanguageItem.name }}</span>
    </a>
    <div class="dropdown-menu" aria-labelledby="dropdown-flag">
      <template v-for="(item, i) in languages">
        <a class="dropdown-item" href="javascript:void(0);" v-bind:data-lang="item.lang" @click.prevent="selectedLanguage(item.lang)">
          <i class="flag-icon  mr-50" :class="`flag-icon-${item.flag}`"></i> {{ item.name }}
        </a>
      </template>
    </div>
  </li>
</template>

<script>
import i18nService from "@/core/services/i18n.service.js";

export default {
  name: "KTDropdownLanguage",
  data() {
    return {
      languages: i18nService.languages
    };
  },
  methods: {
    selectedLanguage(lang) {
      i18nService.setActiveLanguage(lang);

      this.$emit(
        "language-changed",
        this.languages.find(val => {
          return val.lang === lang;
        })
      );

      window.location.reload();
    },
    isActiveLanguage(current) {
      return this.activeLanguage === current;
    }
  },
  computed: {
    activeLanguageItem() {
      return this.languages.find((item) => item.lang === this.activeLanguage)
    },
    activeLanguage() {
      return i18nService.getActiveLanguage();
    }
  }
};
</script>
